import Swatches from "./swatches.vue";

export default Swatches;
